<template>
  <div>
    <div class="content">
      <div class="search">
        <el-input v-model="input3" class="input-with-select" placeholder="请输入内容" style="border: 0">
          <el-select slot="prepend" v-model="select" placeholder="请选择"
                     style="background-color: white;min-width:150px">
            <el-option v-for="(item,index) in list" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
          <el-button slot="append" class="button" @click="search">搜索</el-button>
        </el-input>
      </div>
      <p v-show="searchShow">
        <span class="lx">人事管理</span>
        <span> | </span>
        <span class="lx">劳务派遣</span>
        <span> | </span>
        <span class="lx">薪酬计算</span>
        <span> | </span>
        <span class="lx">薪酬发放</span>
        <span> | </span>
        <span class="lx">代缴社保</span>
      </p>
      <div v-show="searchShow" class="banner">
        <div class="left">
          <el-popover
            v-for="(item,index) in list.slice(1,10)"
            :key="index"
            placement="right"
            style="height:800px" trigger="hover" width="200">
            <div style="max-height:400px;overflow-y:auto;width:200px">
              <div v-for="(items,index) in item.children " :key="index" class="childrens">{{ items.name }}</div>
            </div>
            <div slot="reference" class="box">
              <p>
                <i :class="item.icon"> </i>
                <span> {{ item.name }}</span>
              </p>
              <i class="el-icon-arrow-right"></i>
            </div>
          </el-popover>
        </div>
        <div class="right">
          <el-carousel height="320px" trigger="click">
            <el-carousel-item>
              <img alt="" class="bannerimg" src="../../assets/photo/service1.png">
            </el-carousel-item>
            <el-carousel-item>
              <img alt="" class="bannerimg" src="../../assets/photo/service2.png">
            </el-carousel-item>
          </el-carousel>
          <div class="bottom">
            <div class="card">
              <h1>外籍五险一金代理</h1>
              <p>代缴五险一金,正规社保代理机构,资质齐全正规,可为本地异地员工,各类中小企业解决员工社保缴纳难题。</p>
              <div class="img">
                <img alt="" src="../../assets/photo/bottom1.png">
                <span>查看详情</span>
              </div>
            </div>
            <div class="xian"></div>
            <div class="card">
              <h1>薪税政策培训</h1>
              <p>助力企业打通业财体系,规范经营管理,降低经营成本,保障财富安全。合理合规经营，无后顾之忧。</p>
              <div class="img">
                <img alt="" src="../../assets/photo/bottom1.png">
                <span>查看详情</span>
              </div>
            </div>
            <div class="xian"></div>
            <div class="card">
              <h1>年度体检标准版</h1>
              <p>年度体检使员工享有专业的健康指导;通过健康干预措施，降低员工发病率和亚健康状态，提升员工工作效率。</p>
              <div class="img">
                <img alt="" src="../../assets/photo/bottom1.png">
                <span>查看详情</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="!searchShow" class="category">
        <p>服务类别：</p>
        <div class="select">
          <el-popover
            v-for="(item,index) in list.slice(1,10)"
            :key="index"
            placement="bottom" trigger="hover" width="200">
            <div style="max-height:400px;overflow-y:auto;width:200px"
            >
              <div v-for="(items,index) in item.children " :key="index"
                   :class="clicks.name == items.name ? 'clicks' :''"
                   class="childrens click" @click="chacks(item,items)">{{ items.name }}
              </div>
            </div>
            <div slot="reference" class="box" @click="chack(item)">
              <p :class="click.name == item.name ? 'click' :''">
                <i :class="item.icon"> </i>
                <span> {{ item.name }}</span>
              </p>
            </div>
          </el-popover>
        </div>
      </div>
      <div class="boxList">
        <div v-for="(item,index) in serviceList" :key="index" class="box">
          <div class="boxhead">
            <span>社保大库代理</span>
            <el-rate
              v-model="item.value"
              disabled
              text-color="#ff9900">
            </el-rate>
          </div>
          <p>
            代缴五险一金,正规社保代理机构,资质齐全正规,可为本地异地员工,各类中小企业解决员工社保缴纳难题
          </p>
          <p class="h">
            杭州中智服务外包有限公司
          </p>
          <div class="tags">
            <el-tag
              v-for="items in item.tags"
              :key="items.label"
              :type="items.type"
              effect="plain"
              style="margin-right:20px;margin-top:10px;">
              {{ items.label }}
            </el-tag>
          </div>
          <div class="boxfoot">
            <p>
              <span>￥</span>
              <span>面议</span>
            </p>
            <div class="gobuy" @click="gobuy(item)">
              去购买
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="details">
      <div class=""></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "demo",
  data() {
    return {
      item: {
        backgroundImage:
          "url(" + require("../../assets/photo/we.png") + ")",
      },
      select: '1',
      input3: '',
      list: [
        {
          name: "全部分类",
          icon: '',
          value: '1',
          children: []
        },
        {
          name: "人事管理",
          value: '2',
          icon: 'el-icon-s-home',
          children: [
            {
              name: '中方员工人事管理服务'
            },
            {
              name: '外籍员工人事管理服务'
            },
            {
              name: '户证办理服务'
            },
            {
              name: '工伤办理服务'
            },
            {
              name: '退休办理服务'
            },
            {
              name: '人才服务'
            },
            {
              name: '助残就业服务'
            },
            {
              name: '企业流程代办服务'
            },
            {
              name: '人力资源法务服务'
            },
            {
              name: '企业会员服务'
            },
            {
              name: '其他人事管理服务'
            },

          ]
        },
        {
          value: '3',
          name: "人才派遣",
          icon: 'el-icon-message',
          children: [
            {
              name: '人才派遣服务'
            },
            {
              name: '助残就业服务'
            },
            {
              name: '其他人才派遣服务'
            }
          ]
        },
        {
          name: "薪酬福利",
          icon: 'el-icon-user',
          value: '4',
          children: [
            {
              name: '中方员工薪酬服务'
            },
            {
              name: '外籍员工薪酬服务'
            },
            {
              name: '企业流程代办服务'
            },
            {
              name: '培训服务'
            },
            {
              name: '其他薪酬服务'
            },
            {
              name: '代理记账服务'
            },
            {
              name: '税务服务'
            },
            {
              name: '企业商务服务'
            },
            {
              name: '咨询筹划服务'
            },
            {
              name: '其他财税服务'
            },
            {
              name: '心理援助'
            },
            {
              name: '入职体检'
            },
            {
              name: '年度体检'
            },
            {
              name: '就诊服务'
            },
            {
              name: '口腔服务'
            },
            {
              name: '疫苗服务'
            },
            {
              name: '咨询讲座'
            },
            {
              name: '其他健康服务'
            },
            {
              name: '雇主责任保障'
            },
            {
              name: '人身意外保障'
            },
            {
              name: '交通工具意外保障'
            },
            {
              name: '疾病身故保障'
            },
            {
              name: '补充医疗保障'
            },
            {
              name: '住院补贴保障'
            },
            {
              name: '百万医疗保障'
            },
            {
              name: '重疾保障'
            },
            {
              name: '高端医疗保障'
            },
            {
              name: '商务旅行保障'
            },
            {
              name: '家庭财产保障'
            },
            {
              name: '其他保障服务'
            },
            {
              name: '财产一切保障'
            },
            {
              name: '公众责任保障'
            },
            {
              name: '机损保障'
            },
            {
              name: '其他保障服务'
            },
            {
              name: '年节礼包'
            },
            {
              name: '福利积分'
            },
            {
              name: '文化娱乐'
            },
            {
              name: '特殊津贴'
            },
            {
              name: '员工关怀'
            },
            {
              name: '定制课堂'
            },
            {
              name: '团建活动'
            },
          ]
        },
        {
          name: "业务外包",
          icon: 'el-icon-user',
          value: '5',
          children: [
            {
              name: '项目外包'
            },
            {
              name: '文档管理'
            },
            {
              name: '退休人员档案管理'
            },
            {
              name: '干部人事档案管理'
            },
            {
              name: '人力资源共享服务中心外包'
            },
            {
              name: '政府/园区共享服务中心外包'
            },
            {
              name: '退役军人服务外包'
            },
            {
              name: '营销外包'
            },
            {
              name: '其它服务外包'
            },
          ]
        },
        {
          name: "招聘及灵活用工",
          icon: 'el-icon-user',
          value: '6',
          children: [
            {
              name: '人才寻访'
            }, {
              name: '招聘服务'
            }, {
              name: '招考服务'
            }, {
              name: '校园招聘'
            }, {
              name: '背景调查'
            }, {
              name: '人才测评'
            }, {
              name: '非全日制用工服务'
            }, {
              name: '辅助人员岗位外包/风险外包'
            }, {
              name: '兼职实习服务'
            },
          ]
        },
        {
          name: "管理咨询",
          icon: 'el-icon-user',
          value: '7',
          children: [
            {
              name: '管理咨询'
            }, {
              name: '数据报告'
            }, {
              name: '人才发展'
            }, {
              name: '企业文化'
            },
          ]
        },
        {
          name: "人力资源技术",
          icon: 'el-icon-user',
          value: '8',
          children: [
            {
              name: '企业人事自助平台'
            }, {
              name: '雇员自助平台'
            }, {
              name: '人力资源管理平台'
            }, {
              name: '电子签约平台'
            }, {
              name: '电子档案管理平台'
            }, {
              name: '电子工资单平台'
            }, {
              name: '外籍雇员管理平台'
            }, {
              name: '薪酬管理平台'
            }, {
              name: '弹性福利平台'
            }, {
              name: '健康管理平台'
            }, {
              name: '员工内购平台'
            }, {
              name: '员工激励平台'
            }, {
              name: '心理援助平台'
            }, {
              name: '人才培训平台'
            }, {
              name: '人才测评平台'
            }, {
              name: '招考平台'
            }, {
              name: '招聘平台'
            }, {
              name: '校招平台'
            }, {
              name: '灵活用工平台'
            }, {
              name: '其他人力资源技术服务'
            },
          ]
        },
        {
          name: "国际人力资源",
          icon: 'el-icon-user',
          value: '9',
          children: [
            {
              name: '对外劳务合作'
            },
            {
              name: '其他对外劳务服务'
            },
            {
              name: '境外BPO'
            },
            {
              name: 'EOR'
            },
            {
              name: '境外人事代理'
            },
            {
              name: '其他境外人力资源服务'
            },
          ]
        },
        {
          name: "人力资源媒体",
          icon: 'el-icon-user',
          value: '10',
          children: [
            {
              name: '榜单与评选'
            }, {
              name: '会展及活动'
            }, {
              name: '会员项目'
            }, {
              name: '内容服务'
            }, {
              name: '其他媒体服务'
            },
          ]
        }
      ],
      serviceList: [
        {
          value: 5,
          tags: [
            {type: 'warning', label: '资质齐全'},
            {type: 'warning', label: '廿年经验'},
            {type: 'warning', label: '服务优良'},
          ]
        }, {
          value: 5,
          tags: [
            {type: 'warning', label: '资质齐全'},
            {type: 'warning', label: '廿年经验'},
            {type: 'warning', label: '服务优良'},
          ]
        }, {
          value: 5,
          tags: [
            {type: 'warning', label: '资质齐全'},
            {type: 'warning', label: '廿年经验'},
            {type: 'warning', label: '服务优良'},
          ]
        }, {
          value: 5,
          tags: [
            {type: 'warning', label: '资质齐全'},
            {type: 'warning', label: '廿年经验'},
            {type: 'warning', label: '服务优良'},
          ]
        },
      ],
      searchShow: true,
      click: {
        name: ''
      },
      clicks: {
        name: ''
      }
    };
  },
  mounted() {
  },
  methods: {
    login() {
      this.$router.push({name: 'login'})
    },
    register() {
      this.$router.push({name: 'register'})
    },
    search() {
      this.searchShow = false
    },
    chack(item) {
      this.click = item
    },
    chacks(item, items) {
      this.click = item
      this.clicks = items
    },
    gobuy(item) {

    }
  },
};
</script>

<style lang="less" scoped>
.childrens {
  height: 35px;
  width: 180px;
  line-height: 35px;
  cursor: pointer;
}

.childrens:hover {
  color: rgba(245, 165, 64, 1);
}

.input-with-select {
  border: 0
}

.el-select .el-input {
  width: 130px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.content {
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;

  .search {
    width: 570px;
    border: 2px solid rgba(245, 165, 64, 1);

    .button {
      background-color: rgba(245, 165, 64, 1);
      color: white;
      border-radius: 0;
      border: none;
      margin: -10px -21px;
      padding: 15px 21px;
    }
  }

  p {
    margin-top: 10px;
  }

  .lx {
    cursor: pointer;
  }

  .lx:hover {
    color: rgba(245, 165, 64, 1)
  }

  .banner {
    height: 580px;
    display: flex;
    flex-direction: row;
    justify-content: start;
    width: 100%;
    margin-top: 50px;

    .left {
      width: 256px;
      height: 409px;
      border-right: rgb(233, 233, 233) 1px solid;

      .box {
        height: 45px;
        width: 256px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0px 10px;
      }

      .box:hover {
        color: rgba(245, 165, 64, 1);
      }
    }

    .right {
      width: 940px;
      height: 580px;
      margin-left: calc(50vw - 726px);

      .bannerimg {
        width: 100%;
      }

      .bottom {
        width: 940px;
        height: 235px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .xian {
          height: 175px;
          border: 1px solid rgba(238, 238, 238, 1);
          margin-right: 30px;
        }

        .card {
          padding: 10px;
          width: 292px;

          h1 {
            color: rgba(16, 16, 16, 1);
            font-size: 20px;
          }

          p {
            color: rgba(153, 153, 153, 1);
            font-size: 14px;
          }

          .img {
            margin-top: 30px;
            padding-left: 90px;

            span {
              margin-left: 50px;
              color: rgba(153, 153, 153, 1);
              font-size: 13px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .category {
    p {
      color: rgba(16, 16, 16, 1);
      font-size: 18px;
      text-align: left;
    }

    .select {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      width: 1215px;

      .click {
        background-color: rgba(171, 245, 255, 0.3);
        color: rgba(245, 165, 64, 1);
      }

      .box {
        height: 46px;
        line-height: 46px;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        justify-content: center;

        p {
          height: 46px;
          line-height: 46px;
          padding: 0px 20px;
          font-size: 15px;
        }
      }

    }
  }
}

.clicks {
  background-color: rgba(171, 245, 255, 0.3);
  color: rgba(245, 165, 64, 1);
}

.boxList {
  width: 1233px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .box {
    width: 411px;
    height: 248px;
    padding: 40px;

    .boxhead {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      span {
        color: rgba(24, 24, 24, 1);
        font-size: 18px;
      }
    }

    p {
      color: rgba(153, 153, 153, 1);
      font-size: 12px;
    }

    .h {
      color: rgba(136, 136, 136, 1);
      font-size: 13px;
    }

    .boxfoot {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: 10px;

      p {
        margin: 0;
      }

      span {
        color: rgba(239, 42, 58, 1);
        font-size: 18px;
      }

      .gobuy {
        width: 80px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
        border-radius: 8px;
        background-color: rgba(245, 165, 64, 1);
        color: rgba(255, 255, 255, 1);
        font-size: 14px;
        text-align: center;
      }
    }
  }
}

/deep/ .el-rate__icon {
  font-size: 25px;
}
</style>
